class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const voiceSwiper = new Swiper('.c-swiper-voice', {
      speed: 1000,
      loop: false,
      slidesPerView: 1.2,
      centeredSlides: true,
      spaceBetween: 8,
      navigation: {
        prevEl: ".c-swiper-voice-prev",
        nextEl: ".c-swiper-voice-next",
      },
      pagination: {
        el: '.c-swiper-voice-pagination',
        type: 'progressbar',
      },
      breakpoints: {
        768: {
          centeredSlides: false,
          slidesPerView: 2.7,
          spaceBetween: 18,
        }
      },
    });
        
    const aboutSwiper = new Swiper(".c-swiper-about", {
      effect: "cards",
      grabCursor: false,
      initialSlide: 0,
      speed: 1000,
      cardsEffect: {
        rotate: 0,
        slideShadows: false,
        perspective: 500,
      },
      mousewheel: {
        invert: false,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}